import { render, staticRenderFns } from "./InspiredBy.vue?vue&type=template&id=18dfbf2f"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports